module.exports = __webpack_public_path__ + "assets/network-browser.a7c86aa0.svg";